import { useTranslation } from 'next-i18next'

import { Size } from '~/statistics/types/profile-card.types'

import ActivitySetProgress from '../CircularProgress'

interface Props {
  completedQuizesCount: number
  totalQuizesCount: number
}

export default function ActivitySummary(props: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  const { totalQuizesCount, completedQuizesCount } = props
  const progress = Math.floor((completedQuizesCount / totalQuizesCount) * 100)

  return (
    <div className="w-full font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
      <p className="text-center">
        <span className="text-purple">{t('quizzes')}</span>
      </p>
      <ActivitySetProgress hideCheckmark percentage={progress} size={Size.LARGE} />
      <p className="text-center">
        {completedQuizesCount}/{totalQuizesCount}
      </p>
    </div>
  )
}
